export default "__VITE_ASSET__D35xc$xf__"